import { isAfter } from 'date-fns';

import { convertToSlug } from '../../utils';

import type { IEvent } from '../../types';

export const filterByShortcode =
	(filters: string[], property: string) =>
	(event: IEvent): boolean => {
		if (!Array.isArray(filters) || filters.length === 0) return true;
		if (!Array.isArray(event[property])) return false;
		return event[property].some((filter) => filters.includes(filter));
	};

export const filterByShortcodeVenue =
	(venue?: string) =>
	(event: IEvent): boolean => {
		if (!venue || !event.venue) return true;

		const parsedVenue = parseInt(venue.trim(), 10);
		if (isNaN(parsedVenue)) {
			const venueSlug = convertToSlug(venue);
			return convertToSlug(event.venue.name) === venueSlug;
		} else {
			return event.venue.id === parsedVenue;
		}
	};

export const filterOutExpiredEvents =
	(includeExpired: boolean | undefined) =>
	(event: IEvent): boolean => {
		if (includeExpired === false) {
			const now = new Date();
			return isAfter(event.end, now);
		}
		return true;
	};
